import { createSlice, PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import * as Types from './types';

const initialState: Types.ModalsState = {
  modalType: null,
  modalProps: {},
};

// Reducers
const showModalReducer: CaseReducer<Types.ModalsState, PayloadAction<Types.ShowModalPayload>> = (
  state,
  action
) => {
  const { modalType, modalProps } = action.payload;
  state.modalType = modalType;
  state.modalProps = modalProps;
};

const hideModalReducer: CaseReducer<Types.ModalsState, PayloadAction> = () => initialState;

// Create Slice
const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModal: showModalReducer,
    hideModal: hideModalReducer,
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;
